module.exports = __webpack_public_path__ + "static/assets/b1c54053bcb1b6af1416912889fb8893.png";